<template>
    <v-row
        :class="$vuetify.breakpoint.smAndUp ? 'pl-8' : ''"
    >
        <v-col
            :cols="$vuetify.breakpoint.xsOnly ? 12 : 4"
        >
            <ProfileNavigation selected-tab="user-info" />
        </v-col>
        <v-col v-if="$vuetify.breakpoint.smAndUp">
            <UserInfo />
        </v-col>
    </v-row>
</template>
<script>
import ProfileNavigation from '@/components/ProfileSettings/ProfileNavigation';
import UserInfo from '@/components/ProfileSettings/UserInfo';

export default {
    components: {
        ProfileNavigation,
        UserInfo,
    },
};
</script>
